import { useEffect, useState } from "react";
import { BINARY_SYSTEM, MAYA_SYSTEM, REPEATS, ROMAN_SYSTEM } from "./defaults";
import Level0Binary from "./levels/level0Binary";
import Level0Maya from "./levels/level0Maya";
import Level0Roman from "./levels/level0Roman";
import Level1Binary from "./levels/level1Binary";
import Level1Maya from "./levels/level1Maya";
import Level1Roman from "./levels/level1Roman";
import Level2Binary from "./levels/level2Binary";
import Level2Maya from "./levels/level2Maya";
import Level2Roman from "./levels/level2Roman";
import Level3Binary from "./levels/level3Binary";
import Level3Maya from "./levels/level3Maya";
import Level3Roman from "./levels/level3Roman";
import Level4Binary from "./levels/level4Binary";
import Level4Maya from "./levels/level4Maya";
import Level4Roman from "./levels/level4Roman";
import Level5Binary from "./levels/level5Binary";
import Level5Roman from "./levels/level5Roman";
import Level6Binary from "./levels/level6Binary";
import Level7Binary from "./levels/level7Binary";

function Level({
  level,
  progress,
  setProgress,
  levelProgress,
  setLevelProgress,
  showMessage,
  setShowMessage,
  disableInput,
  setDisableInput,
  whichSystem,
  numberOfLevels
}) {
  const [renderedComponent, setRenderedComponent] = useState(null);

  useEffect(() => {
    if (
      levelProgress(whichSystem)[level] >= REPEATS &&
      level === progress(whichSystem) &&
      progress(whichSystem) < numberOfLevels(whichSystem)
    ) {
      setProgress(whichSystem, progress(whichSystem) + 1);
    }
  }, [levelProgress, level, progress, setProgress]);

  useEffect(() => {
    const renderLevelComponent = () => {
      const levelProgressFixed = levelProgress(whichSystem);
      switch (whichSystem) {
        case ROMAN_SYSTEM:
          switch (level) {
            case 0:
              return <Level0Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 1:
              return <Level1Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 2:
              return <Level2Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 3:
              return <Level3Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 4:
              return <Level4Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 5:
              return <Level5Roman levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            default:
              return <div>Level {level} not implemented yet for Roman System</div>;
          }
        case BINARY_SYSTEM:
          switch (level) {
            case 0:
              return <Level0Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 1:
              return <Level1Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 2:
              return <Level2Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 3:
              return <Level3Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 4:
              return <Level4Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 5:
              return <Level5Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 6:
              return <Level6Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 7:
              return <Level7Binary levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            default:
              return <div>Level {level} not implemented yet for Binary System</div>;
          }
        case MAYA_SYSTEM:
          switch (level) {
            case 0:
              return <Level0Maya levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 1:
              return <Level1Maya levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 2:
              return <Level2Maya levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 3:
              return <Level3Maya levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            case 4:
              return <Level4Maya levelProgress={levelProgressFixed} setLevelProgress={setLevelProgress} showMessage={showMessage} setShowMessage={setShowMessage} disableInput={disableInput} setDisableInput={setDisableInput}/>;
            default:
              return <div>Level {level} not implemented yet for Maya System</div>;
          }
        default:
          return <div>System {whichSystem} not implemented yet</div>;
      }
    };
    setRenderedComponent(renderLevelComponent());
  }, [
    level,
    levelProgress,
    setLevelProgress,
    progress,
    whichSystem
  ]);

  return (
    <div>
      {renderedComponent}
    </div>
  );
}

export default Level;
